import { render } from "./ConfigForm.vue?vue&type=template&id=6ac0af3f"
import script from "./ConfigForm.vue?vue&type=script&lang=js"
export * from "./ConfigForm.vue?vue&type=script&lang=js"
script.render = render

export default script